export default __webpack_public_path__ + "static/media/p3-homepage.3a606f3e.png";